module.exports = __webpack_public_path__ + "static/media/pdp_paperSmooth.57c38d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/papertypes/pdp_paperSmooth.jpg
// module id = 1549
// module chunks = 70